module.exports = __webpack_public_path__ + "static/img/canyuchoujiang.8615308f.png";